module.exports = require("lodash/kebabCase");